/**
 * 經營儀表（Overseas patch 304）
 */
export const OPS_ANALYTICS_MENU_IDS = {
  desk: 991078,
  view: 991079
}

export default OPS_ANALYTICS_MENU_IDS



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/constants/opsAnalytics.js